import crm from './crm';

const TicketCategoria = {
	index:(filtros)=>{
		return crm.get('/ticket-categoria', {params: filtros});
	},
	show:(id)=>{
		return crm.get('/ticket-categoria/'+id);
	},
	update: (dados, id) => {
        let uri = '/ticket-categoria/' + id;
        return crm['put'].call(crm, uri, {categoria: dados});
    },
	store: (dados) => {
        let uri = '/ticket-categoria';
        return crm['post'].call(crm, uri, {categoria: dados});
    },
    delete:(id)=>{
        return crm.delete('/ticket-categoria/'+id);
    },
};

export default TicketCategoria;
